import * as React from "react";

import "VSS/LoaderPlugins/Css!Agile/Scripts/BoardsHub/TeamBoardPivot/Components/BoardPivot";
import { ITeamBoardPivotContext } from "Agile/Scripts/BoardsHub/BoardsHubContracts";
import { PivotItemContent } from "Agile/Scripts/Common/Components/PivotItemContent";
import { BoardsHubConstants } from "Agile/Scripts/Generated/HubConstants";
import { component } from "Agile/Scripts/Common/Components/ComponentRegistration";
import { BacklogsAnalyticsView } from "../../BacklogsHub/AnalyticsPivot/BacklogsAnalyticsView";
import { ITeam } from "Agile/Scripts/Models/Team";
import { getDefaultWebContext } from "VSS/Context";
import { getLevelSelectorViewAction } from "Agile/Scripts/Common/ViewActions/BacklogLevelSelectorViewAction";
import { VssIconType } from "VSSUI/VssIcon";
import { IPivotBarViewAction, PivotBarViewActionArea } from "VSSUI/PivotBar";
import { HubViewActions } from "Agile/Scripts/Common/HubViewActions";
import { HubViewOptionKeys } from "VSSUI/Utilities/HubViewState";

interface IBoardAnalyticsPivotProps extends ITeamBoardPivotContext { 
    team: ITeam;
}

interface IBoardAnalyticsPivotState {
    lastRefresh?: Date;
    
    /** Describes if page has finished initial load. */
    isDataReady: boolean;
}

@component("boards-analytics-pivot")
export class BoardAnalyticsPivot extends PivotItemContent<IBoardAnalyticsPivotProps, IBoardAnalyticsPivotState> {
    constructor(props: ITeamBoardPivotContext, context?: any) {
        super(props, context, BoardsHubConstants.HUB_NAME, props.pivotName);
        this.state = {
            isDataReady: false
        };
    }

    public render(): JSX.Element {
        const reportSettings = {
            teamId: this.props.team.id,
            teamName: this.props.team.name,
            projectId: getDefaultWebContext().project.id,
            categoryReferenceName: this.props.currentBacklog.id,
            categoryName:this.props.currentBacklog.name,
            lastRefresh: this.state.lastRefresh,
            onLoadCompleted: this.onLoadCompleted,
            isFullScreen: this.props.viewOptions.getViewOption(HubViewOptionKeys.fullScreen,), //Whenever the full screen state changes, we want to trigger a re-render and get a completion notification back to boards page framework
            telemetryProps: {
                parentPageName: "BoardsHub",
                area: "Boards"
            }
        };
        return (
            <div className="board-analytics-content analytics-report-container">
                {<BacklogsAnalyticsView {...reportSettings}/>}                
            </div>
        );
    }

    public getViewActions(props: ITeamBoardPivotContext): IPivotBarViewAction[] {
        const viewActions =  [
            getLevelSelectorViewAction(
                props.visibleBacklogLevels,
                props.viewOptions,
                /* canSwitchLevels */ null,
                "Boards",
                {
                    iconName: "BacklogBoard",
                    iconType: VssIconType.fabric
                }
            ),
            HubViewActions.getRefreshAction(this.onRefreshClick, PivotBarViewActionArea.farRight)
        ];
        return viewActions;
    }

    public isDataReady(): boolean {
        return this.state.isDataReady;
    }

    public onRefreshClick = () : void => {
        this.setState({ lastRefresh: new Date() });
    }
        
    public onLoadCompleted = () : void => {
        this.setState({ isDataReady: true });
    }
    
    protected shouldUpdateViewActionsOnUpdate(nextProps: IBoardAnalyticsPivotProps, nextState: IBoardAnalyticsPivotState): boolean {
        return true;
    }
}